export const ZOR_CARD_SECTION_TITLES = {
  mcom: {
    notSignedIn: 'Our picks for you',
    signedIn: 'Our picks for you',
  },
  bcom: {
    notSignedIn: 'MORE GREAT FINDS',
    signedIn: 'RECOMMENDED FOR YOU',
  },
};

export const ZOR_TAB_SECTION_TITLES = {
  mcom: {
    notSignedIn: "Don't miss these finds",
    signedIn: 'Ready to find new favorites?',
  },
  bcom: {
    notSignedIn: 'RECOMMENDED FOR YOU',
    signedIn: 'RECOMMENDED FOR YOU',
  },
};

export const ZOR_TAB_EXPERIMENT_TREATMENT_ID = '3218-21';
